import { useCallback, useMemo } from 'react';
import { StationaryArea } from '@thive/fddm-types';

import { SelectInput } from '@common/components/inputs';
import { useReadSelectedAreas } from '@/modules/floorplanDesign/hooks';
import { areasToFlatCollection, isStationaryArea } from '@/modules/floorplanDesign/helpers';
import { FddmServiceFactory } from '@/modules/canvas/services/Floorplan/FddmServiceFactory';

const STATIONARY_TYPE_OPTIONS: {
  label: string;
  value: StationaryArea['stationaryType'];
}[] = [
  { label: 'Parking', value: 'PARKING' },
  { label: 'Charging', value: 'CHARGING' },
  { label: 'Insertion', value: 'INSERTION' },
  { label: 'Extraction', value: 'EXTRACTION' },
];

function StationaryType() {
  const selectedAreas = useReadSelectedAreas();
  const fddmSvc = useMemo(() => FddmServiceFactory.getInstance().createFddmService(), []);

  const stationaryType = useMemo(() => {
    const areas = areasToFlatCollection(selectedAreas);
    if (areas.length !== 1) return;
    const area = areas[0];
    if (!isStationaryArea(area)) return;

    const { stationaryType } = area;
    return stationaryType;
  }, [selectedAreas]);

  const onChange = useCallback(
    (newValue: StationaryArea['stationaryType']) => {
      const areas = areasToFlatCollection(selectedAreas);
      if (areas.length !== 1) return;
      const area = areas[0];
      if (!isStationaryArea(area)) return;

      fddmSvc.updateArea({
        ...area,
        stationaryType: newValue,
      });
    },
    [selectedAreas, fddmSvc],
  );

  if (stationaryType === undefined) return null;

  return (
    <SelectInput options={STATIONARY_TYPE_OPTIONS} onChange={onChange} value={stationaryType} />
  );
}

export default StationaryType;
